import React, { Component } from "react";
import {
  Col,
  Button,
  Row,
  FormGroup,
  Popover,
  Modal,
  ModalBody,
  Media,
  timeoutsShape,
  Input,
} from "reactstrap";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import Select from "react-select";
import {
  UserRole,
  UserRoles,
  roleOptions,
  dynamic_urls,
  renderGenderPronoun,
  profilePicValidityCheck,
  isTrivvyUrl,
  manageRoleText,
  get_user_initials,
} from "../../../../utils/constants";
import warningIcon from "../../../../assets/warning.svg";
import "./OfficeMate.css";
import InfoMessage from "../../../../components/Message/InfoMessage/InfoMessage";
import { isMobile } from "../../../../utils/deviceInfo";
import If from "../../../../components/Shared/If";
import { getFlatDataFromTree } from "react-sortable-tree";
import { BiEditAlt, BiEnvelope, BiMailSend, BiMessage } from "react-icons/bi";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import ReactTooltip from "react-tooltip";
import { toastContainer } from "../../../../utils/toast";
import { LuBadgeCheck } from "react-icons/lu";
import moment from "moment";
import CheckBox from "rc-checkbox";
import { MdOutlineMobileFriendly } from "react-icons/md";
import { EMPTY_VALUE_LABEL } from "../../../../utils/constants";
import { USER_ID_SAVED_SUCCESS } from "../../../../utils/registrationValidationStrings";
import { columnWidthStyle } from "../../../user/Users/usersColumns";

export default class OfficeMate extends Component {
  // {'officeName': this.props.officeMate.officeId.name,
  //             'officeHierarchyPath': this.props.officeMate.officeId.officeHierarchyPath}
  constructor(props) {
    super(props);
    this.state = {
      officeMateRole: {
        key: manageRoleText(this.props.officeMate),
        value: manageRoleText(this.props.officeMate),
      },
      selectedOffice:
        this.props.officeMate &&
        this.props.officeMate.officeId &&
        this.props.officeMate.officeId !== null
          ? {
              officeName: this.props.officeMate.officeId.name,
              officeHierarchyPath: this.props.officeMate.officeId
                .officeHierarchyPath,
            }
          : null,
      removeUserPopoverOpen: false,
      showRemoveUserConfirmationModal: false,
      showAddMember: false,
      allOfficesWithInvitations: [],
      // Every inline editor keeps two copies of its value: the saved one the
      // row displays, and a draft the inputs edit. Only a successful Save
      // copies the draft into the saved value; Close just discards the draft.
      editPhoneNumberOpen: false,
      officeMateMobileNumber: this.props.officeMate.mobileNumber || "",
      officeMateMobileNumberDraft: "",
      editEmailOpen: false,
      officeMateEmail: this.props.officeMate.email || "",
      officeMateIsDummyEmail: this.props.officeMate.isDummyEmail === true,
      officeMateEmailDraft: "",
      editNameOpen: false,
      officeMateFirstName: this.props.officeMate.firstName || "",
      officeMateLastName: this.props.officeMate.lastName || "",
      officeMateFirstNameDraft: "",
      officeMateLastNameDraft: "",
      editEmployeeIdOpen: false,
      officeMateEmployeeId: this.props.officeMate.employeeId || "",
      officeMateEmployeeIdDraft: "",
    };

    // console.log(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const prev = this.props.officeMate;
    const next = nextProps.officeMate;
    // Saved values follow the parent only when the parent's value actually
    // changes, so an unrelated re-render can't overwrite a value saved here
    // (the Office Mates page passes no change handlers, so its props go stale).
    // Drafts are never touched, so typing is never reset mid-edit.
    this.setState({
      officeMateRole: {
        key: manageRoleText(next),
        value: manageRoleText(next),
      },
      ...(next.email !== prev.email && { officeMateEmail: next.email || "" }),
      ...(next.isDummyEmail !== prev.isDummyEmail && {
        officeMateIsDummyEmail: next.isDummyEmail === true,
      }),
      ...(next.mobileNumber !== prev.mobileNumber && {
        officeMateMobileNumber: next.mobileNumber || "",
      }),
      ...(next.employeeId !== prev.employeeId && {
        officeMateEmployeeId: next.employeeId || "",
      }),
      ...(next.firstName !== prev.firstName && {
        officeMateFirstName: next.firstName || "",
      }),
      ...(next.lastName !== prev.lastName && {
        officeMateLastName: next.lastName || "",
      }),
    });
  }

  handleRoleChange = (role) => {
    if (this.props.changeToAdminDisabled && role.value == "Admin") {
      return;
    }

    // Block role change to Admin/EA for users without a real email on file.
    const targetIsAdminOrEA = role.value === "Admin" || role.orgAdmin === true;
    const { officeMateEmail, officeMateIsDummyEmail } = this.state;
    const hasNoEmail =
      !officeMateEmail ||
      officeMateEmail.toString().trim() === "" ||
      officeMateIsDummyEmail;
    if (targetIsAdminOrEA && hasNoEmail) {
      toastContainer(
        "You must first add an Email for a User, before changing their role to EA or Admin.",
        "error"
      );
      return;
    }

    let payload = {
      role: role.value,
      currentRole: this.props.officeMate.role,
      orgAdmin: role.orgAdmin,
    };
    console.log(this.props);
    console.log(role, this.props.officeMate);
    // if(this.props.officeMate.role==="Member"){
    //     let office= {
    //         officeName: this.props.user.officeId.name,
    //         officeHierarchyPath: this.props.user.officeHierarchyPath
    //     }
    //     this.setState({selectedOffice:office})
    // } else if (role.value==="Member"){

    //     this.setState({selectedOffice:null})
    // }
    this.setState({ selectedOffice: null });

    axios
    .put(url.changeRole(this.props.officeMate._id), payload)
    .then((data) => {
      this.props.onRoleChange({
        _id: this.props.officeMate._id,
        role: role.value,
        orgAdmin: role.orgAdmin,
        previousRole: this.props.officeMate.role,
        officeId: this.props.user.officeId,
        officeHierarchyPath: this.props.user.officeHierarchyPath,
      });

      // Notify if user changed to Admin/EA and hasn't registered yet
      var isAdminOrEA = role.value === "Admin" || role.orgAdmin === true;
      var hasNotRegistered = !this.props.officeMate.isPasswordChanged;
      if (isAdminOrEA && hasNotRegistered) {
        toastContainer(
          "Remember to use Invite by Email in the dropdown to ensure the user registers and can perform their role on the platform.",
          "info"
        );
      }
    })
    .catch((error) => {
      console.log("Change Role Error");
    });
  };

  handleOfficeChange = (office) => {
    // console.log(office)

    this.setState({
      selectedOffice: office,
    });
    let payload = {
      userId: this.props.officeMate._id,
      office,
      orgId: this.props.officeMate.organizationId,
    };
    axios
      .post(url.changeUserOffice, payload)
      .then((data) => {
        let user = data.data.data;
        this.props.onOfficeChange(user);
      })
      .catch((error) => {
        console.log("Change Role Error");
      });
  };

  removeOfficeMate = () => {
    axios
      .delete(url.removeOfficeMate + this.props.officeMate._id)
      .then(() => {
        this.props.onUserRemoved();
      })
      .catch(() => {
        console.log("Change Role Error");
      });
  };

  toggleRemoveUserPopover = () => {
    this.setState({
      removeUserPopoverOpen: !this.state.removeUserPopoverOpen,
    });
  };

  navigateToProfile = (profilePicSrc) => {
    // console.log(this.props)

    if (isMobile) return;
    let link = "";
    let profileURL = dynamic_urls(
      this.props.officeMate,
      this.props.officeMate.organizationId
    ).my_profile;

    if (this.props.user._id === this.props.officeMate._id) {
      this.props.history.push({
        pathname: profileURL,
      });
    } else {
      // /:orgId/profile/:id
      this.props.history.push({
        pathname: profileURL,
        // `/home/${this.props.officeMate.organizationId}/profile/${this.props.officeMate._id}`
        state: {
          officeMate: this.props.officeMate,
          profilePicSrcIndex: profilePicValidityCheck(
            this.props.officeMate.profilePic
          )
            ? -1
            : this.props.rowIndex % 3,
        },
      });
    }
  };

  addOfficeMate = (user) => {
    // console.log(user)
    // this.setState({showAddMember: true})
    axios
      .post(url.addMemberInOffice, user)
      .then((data) => {
        let newrole = data.data.role;
        // console.log(data)
        this.props.onRoleChange({
          _id: this.props.officeMate._id,
          role: "User",
        });
        this.setState({ showAddMember: false });
      })
      .catch((error) => {
        console.log("Change Role Error");
      });
  };

  // renderUserOffices = (officeMate) =>{
  //     let {user, allOfficesWithInvitations} = this.props
  //     let {selectedOffice} = this.state
  //     // console.log(user.role, user)
  //     if(user.orgAdmin){
  //         return(<Col sm={3} className="d-flex align-items-center">
  //             <div style={{ width: '100%' }}>
  //                 <Select
  //                     name="role-select"
  //                     value={selectedOffice}
  //                     placeholder="Select Office"
  //                     onChange={(office) => this.handleOfficeChange(office)}
  //                     options={allOfficesWithInvitations}
  //                     valueKey='officeHierarchyPath'
  //                     labelKey='officeName'
  //                     clearable={false}
  //                 />
  //             </div>
  //         </Col>)
  //     } else if(!user.orgAdmin && user.role=="Admin"){
  //         if(officeMate.orgAdmin || officeMate._id===user._id){
  //             return (<Col sm={3} className="d-flex align-items-center">
  //                 {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}
  //             </Col>)
  //         } else if(officeMate.role!=="Member") {
  //             return (
  //             <Col sm={3} className="d-flex align-items-center">
  //                                 {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}

  //                 {/* <div style={{ width: '100%' }}>
  //                     <Select
  //                         name="role-select"
  //                         value={selectedOffice}
  //                         placeholder="Select Office"
  //                         onChange={(office) => this.handleOfficeChange(office)}
  //                         options={allOfficesWithInvitations}
  //                         valueKey='officeHierarchyPath'
  //                         labelKey='officeName'
  //                         clearable={false}
  //                     />
  //                 </div>                     */}
  //             </Col>)
  //         } else {
  //             return(
  //             <Col sm={3} className="d-flex align-items-center">
  //             {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}
  //             </Col>)
  //         }
  //     } else {
  //         return (
  //             <Col sm={3} className="d-flex align-items-center">
  //                 {selectedOffice && selectedOffice.officeName!==null? selectedOffice.officeName: "No Office Selected"}
  //             </Col>
  //         )
  //     }
  // }

  showUserRoles = (officeMateRole) => {
    const { user } = this.props;
    if (user.role === "Admin" && user.orgAdmin) {
      return roleOptions;
    }

    if (user.role === "Admin" && !user.orgAdmin) {
      // Cannot demote an Admin
      if (officeMateRole === "Admin") {
        return roleOptions.filter((e) => e.value !== "Enterprise Admin" && e.value !== "User");
      }
      return roleOptions.filter((e) => e.value !== "Enterprise Admin");
    }

    return [];
  };

  openMobileNumberEditor = () => {
    this.setState({
      editPhoneNumberOpen: true,
      officeMateMobileNumberDraft: this.state.officeMateMobileNumber || "",
    });
  };

  closeMobileNumberEditor = () => {
    this.setState({ editPhoneNumberOpen: false, officeMateMobileNumberDraft: "" });
  };

  saveOfficeMateMobileNumber = () => {
    // Capture the draft so a keystroke during the request can't change what
    // is committed on success.
    const mobileNumber = this.state.officeMateMobileNumberDraft || "";
    axios
      .put(url.changeMobileNumber(this.props.officeMate._id), {
        mobileNumber,
      })
      .then((data) => {
        if (this.props.handleMobileNumberChange) {
          this.props.handleMobileNumberChange({
            _id: this.props.officeMate._id,
            mobileNumber,
          });
        }
        toastContainer("Mobile number updated successfully", "success");
        this.setState({
          editPhoneNumberOpen: false,
          officeMateMobileNumber: mobileNumber,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  openEmailEditor = () => {
    this.setState({
      editEmailOpen: true,
      officeMateEmailDraft: this.state.officeMateIsDummyEmail
        ? ""
        : this.state.officeMateEmail || "",
    });
  };

  closeEmailEditor = () => {
    this.setState({ editEmailOpen: false, officeMateEmailDraft: "" });
  };

  saveOfficeMateEmail = () => {
    const email = this.state.officeMateEmailDraft || "";
    axios
      .put(url.changeEmailId(this.props.officeMate._id), {
        email,
      })
      .then((data) => {
        const updatedUser = data.data;
        const isDummyEmail =
          updatedUser && updatedUser.data && updatedUser.data.isDummyEmail === true;
        if (this.props.handleEmailChange) {
          this.props.handleEmailChange({
            _id: this.props.officeMate._id,
            email,
            isDummyEmail,
          });
        }
        toastContainer("Email saved successfully", "success");
        this.setState({
          editEmailOpen: false,
          officeMateEmail: email,
          officeMateIsDummyEmail: isDummyEmail,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  openEmployeeIdEditor = () => {
    this.setState({
      editEmployeeIdOpen: true,
      officeMateEmployeeIdDraft: this.state.officeMateEmployeeId || "",
    });
  };

  closeEmployeeIdEditor = () => {
    this.setState({ editEmployeeIdOpen: false, officeMateEmployeeIdDraft: "" });
  };

  saveOfficeMateEmployeeId = () => {
    const employeeId = (this.state.officeMateEmployeeIdDraft || "").trim();
    axios
      .put(url.changeEmployeeId(this.props.officeMate._id), { employeeId: employeeId })
      .then(() => {
        if (this.props.handleEmployeeIdChange) {
          this.props.handleEmployeeIdChange({ _id: this.props.officeMate._id, employeeId: employeeId });
        }
        toastContainer(USER_ID_SAVED_SUCCESS, "success");
        this.setState({ editEmployeeIdOpen: false, officeMateEmployeeId: employeeId });
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.errors) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  // bug929 (10/16): the Users list "User ID" cell, editable by Admins like the Email cell.
  renderEmployeeIdCell = (editIconClassName) => {
    const { officeMate, user } = this.props;
    const {
      editEmployeeIdOpen,
      officeMateEmployeeId,
      officeMateEmployeeIdDraft,
      officeMateRole,
    } = this.state;
    const isSelf = String(user._id) === String(officeMate._id);
    const canEdit =
      (isSelf && user.role === "Admin") ||
      user.orgAdmin ||
      (user.role === "Admin" && officeMateRole.value === "User");

    if (editEmployeeIdOpen) {
      return (
        <div className="w-100">
          <Input
            value={officeMateEmployeeIdDraft}
            onChange={(e) => {
              this.setState({ officeMateEmployeeIdDraft: e.target.value });
            }}
          />
          {this.renderEditActions(this.saveOfficeMateEmployeeId, this.closeEmployeeIdEditor)}
        </div>
      );
    }

    return (
      <div className="d-flex align-items-center mw-100">
        <span className="font-13px">
          {officeMateEmployeeId ? officeMateEmployeeId : EMPTY_VALUE_LABEL}
        </span>
        {canEdit && (
          <BiEditAlt
            onClick={this.openEmployeeIdEditor}
            className={editIconClassName}
          />
        )}
      </div>
    );
  };

  // Save and Close always sit side by side, whatever the column width.
  renderEditActions = (onSave, onClose) => {
    return (
      <div className="mt-2 d-flex flex-nowrap align-items-center om-edit-actions">
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onSave();
          }}
          color="success"
          size="sm"
        >
          Save
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          color="danger"
          className="ml-2"
          size="sm"
        >
          Close
        </Button>
      </div>
    );
  };

  openNameEditor = () => {
    this.setState({
      editNameOpen: true,
      officeMateFirstNameDraft: this.state.officeMateFirstName || "",
      officeMateLastNameDraft: this.state.officeMateLastName || "",
    });
  };

  closeNameEditor = () => {
    this.setState({
      editNameOpen: false,
      officeMateFirstNameDraft: "",
      officeMateLastNameDraft: "",
    });
  };

  saveOfficeMateNames = () => {
    // Capture the drafts being saved so a keystroke during the request can't
    // change what is committed on success.
    const firstName = this.state.officeMateFirstNameDraft;
    const lastName = this.state.officeMateLastNameDraft;
    axios
      .put(url.changeUserNames(this.props.officeMate._id), {
        firstName,
        lastName,
      })
      .then((data) => {
        if (this.props.handleNameChange) {
          this.props.handleNameChange({
            _id: this.props.officeMate._id,
            firstName,
            lastName,
          });
        }
        toastContainer("Name saved successfully", "success");
        this.setState({
          editNameOpen: false,
          officeMateFirstName: firstName,
          officeMateLastName: lastName,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  reInviteViaEmail = () => {
    const { officeMate } = this.props;
    axios
      .post(url.reInviteUsers, {
        user: officeMate,
        inviteViaEmail: true,
      })
      .then(({ data }) => {
        if (this.props.handleInviteDateChange) {
          this.props.handleInviteDateChange(data.data);
        }
        toastContainer("Invited successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while inviting user", "error");
      });
  };

  reInviteViaSMS = () => {
    const { officeMate } = this.props;
    axios
      .post(url.reInviteUsers, {
        user: officeMate,
        inviteViaSMS: true,
      })
      .then(({ data }) => {
        if (this.props.handleInviteDateChange) {
          this.props.handleInviteDateChange(data.data);
        }
        toastContainer("Invited successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while inviting user", "error");
      });
  };

  render() {
    let {
      officeMate,
      userRole,
      user,
      allOfficesWithInvitations,
      userSelectedForRemove,
      removeChecked,
      columnWidths,
    } = this.props;
    // bug929: only the Users list renders the User ID column; the legacy Office Mates page keeps its layout.
    const showUserIdColumn = this.props.showUserIdColumn === true;
    // console.log(officeMate,'----',selectedOffice)

    let {
      removeUserPopoverOpen,
      selectedOffice,
      showRemoveUserConfirmationModal,
      officeMateRole,
      showAddMember,
      editPhoneNumberOpen,
      officeMateMobileNumber,
      officeMateMobileNumberDraft,
      editEmailOpen,
      officeMateEmail,
      officeMateIsDummyEmail,
      officeMateEmailDraft,
      editNameOpen,
      officeMateFirstName,
      officeMateLastName,
      officeMateFirstNameDraft,
      officeMateLastNameDraft,
    } = this.state;
    const displayedEmail = officeMateIsDummyEmail
      ? EMPTY_VALUE_LABEL
      : officeMateEmail || EMPTY_VALUE_LABEL;
    let roleView = null;
    let moreView = null;
    let officeMateImageView = null;
    let disableRoleChange = true;
    if (officeMate._id === this.props.user._id || user) {
      disableRoleChange = true;
    }
    if (user.orgAdmin) {
      disableRoleChange = false;
    }

    if (
      user.role === "Admin" &&
      user.officeId &&
      officeMate.officeId &&
      user.officeId._id.toString() === officeMate.officeId.toString() &&
      !officeMate.orgAdmin
    ) {
      disableRoleChange = false;
    }

    if (profilePicValidityCheck(officeMate.profilePic)) {
      officeMateImageView = (
        <img src={officeMate.profilePic} className="officemate-img" />
      );
    } else {
      officeMateImageView = (
        <span
          className="officemate-initials"
          data-letters={get_user_initials(officeMate)}
        />
      );
    }

    if (userRole != "") {
      if (this.props.user.role !== "Member") {
        // console.log('officeM---', officeMate)

        const currentUser = this.props.user;
        const targetUser = this.props.officeMate;

        const isEnterpriseAdmin = currentUser.role === "Admin" && currentUser.orgAdmin;
        const isRegularAdmin = currentUser.role === "Admin" && !currentUser.orgAdmin;
        const isTargetAdmin = targetUser.role === "Admin";
        const isTargetOrgAdmin = targetUser.orgAdmin;

        // Enterprise Admin — can edit anyone
        const showDropdown =
          isEnterpriseAdmin ||
          (isRegularAdmin && !isTargetAdmin); // Regular Admins can only edit non-admins

        roleView = showDropdown ? (
          <div style={{ width: "100%" }}>
            <Select
              name="role-select"
              value={officeMateRole}
              onChange={(role) => this.handleRoleChange(role)}
              options={this.showUserRoles(officeMateRole)}
              /* "value", not "key": roleOptions (constants.js:2556) has no
                 `key`, so is-selected never matched and no option was ticked. */
              valueKey="value"
              labelKey="value"
              clearable={false}
              disabled={false}
            />
          </div>
        ) : (
          <div style={{ width: "100%" }}>
            {manageRoleText(targetUser)}
          </div>
        );

        moreView =
          !disableRoleChange && !isMobile ? (
            user.orgAdmin && officeMate._id != user._id ? (
              <div className="om-row-action">
                <i
                  className="flaticon-menu cursor-pointer"
                  style={{ color: "#C3C4C7" }}
                  id={"removeUserPopover" + officeMate._id}
                  onClick={() => {
                    this.setState((state) => ({
                      removeUserPopoverOpen: !state.removeUserPopoverOpen,
                    }));
                  }}
                ></i>
                <Popover
                  placement="bottom-end"
                  className="top-dd-bg1 remove-officemate"
                  isOpen={removeUserPopoverOpen}
                  target={"removeUserPopover" + officeMate._id}
                  toggle={() => {
                    this.setState((state) => ({
                      removeUserPopoverOpen: !state.removeUserPopoverOpen,
                    }));
                  }}
                >
                  <div className="remove-popover-wrapper">
                    <div
                      className="remove-user-txt"
                      onClick={() => {
                        this.setState((state) => ({
                          showRemoveUserConfirmationModal: !state.showRemoveUserConfirmationModal,
                          removeUserPopoverOpen: !state.removeUserPopoverOpen,
                        }));
                      }}
                    >
                      <span
                        className="flaticon-minus user-minus-icon"
                        style={{ marginRight: "11px" }}
                      ></span>
                      <span className="remove-txt">
                        Remove from Organization
                      </span>
                    </div>

                    {!officeMate.isPasswordChanged && (
                      <div
                        className="remove-user-txt"
                        onClick={() => {
                          this.reInviteViaEmail();
                        }}
                      >
                        <BiEnvelope />
                        <span className="remove-txt ml-2">
                          Invite via Email
                        </span>
                      </div>
                    )}
                    {!officeMate.isPasswordChanged &&
                    officeMate.mobileNumber ? (
                      <div
                        className="remove-user-txt"
                        onClick={() => {
                          this.reInviteViaSMS();
                        }}
                      >
                        <BiMessage />
                        <span className="remove-txt ml-2">Invite via SMS</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Popover>
              </div>
            ) : null
          ) : null;
      } else {
        console.log(this.props, "---officeM---", officeMate);
        roleView = (
          <div style={{ width: "100%" }}>{manageRoleText(this.props.officeMate)}</div>
        );
        moreView =
          !disableRoleChange && !isMobile && user.orgAdmin ? (
            <div className="om-row-action">
              <i
                className="flaticon-menu cursor-pointer"
                style={{ color: "#C3C4C7" }}
                id={"removeUserPopover" + officeMate._id}
                onClick={() => {
                  this.setState((state) => ({
                    removeUserPopoverOpen: !state.removeUserPopoverOpen,
                  }));
                }}
              ></i>
              <Popover
                placement="bottom-end"
                className="top-dd-bg1 remove-officemate"
                isOpen={removeUserPopoverOpen}
                target={"removeUserPopover" + officeMate._id}
                toggle={() => {
                  this.setState((state) => ({
                    removeUserPopoverOpen: !state.removeUserPopoverOpen,
                  }));
                }}
              >
                <div className="remove-popover-wrapper">
                  <span
                    className="remove-user-txt d-flex justify-content-center"
                    onClick={() => {
                      this.setState((state) => ({
                        showRemoveUserConfirmationModal: !state.showRemoveUserConfirmationModal,
                        removeUserPopoverOpen: !state.removeUserPopoverOpen,
                      }));
                    }}
                  >
                    <span
                      className="flaticon-minus user-minus-icon"
                      style={{ marginRight: "11px" }}
                    ></span>
                    <span className="remove-txt">
                      Remove from Organization{" "}
                    </span>
                  </span>
                </div>
              </Popover>
            </div>
          ) : null;
      }
    } else if (
      userRole !== UserRole.admin &&
      officeMate.role === UserRole.admin &&
      officeMate.role !== "Member"
    ) {
      roleView = <div className="user-office-role">Admin</div>;
    }

    const formHeight = isMobile ? "45px" : "90px";
    // console.log(this.props.allOfficesWithInvitations)

    const modalUI = () => {
      return (
        <div>
          <Modal isOpen={showRemoveUserConfirmationModal} className="bwai-remove-modal">
            <ModalBody>
              <Row>
                <Col sm={{ size: 12 }} md={{ size: 12 }}>
                  <div className="remove-officemate-modal-title">
                    Remove Member
                  </div>
                  <div className="bwai-remove-modal-lede">
                    You are about to remove{" "}
                    <strong>
                      {[officeMate.firstName, officeMate.lastName]
                        .filter(Boolean)
                        .join(" ") || officeMate.email}
                    </strong>{" "}
                    from your organization.
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 12 }} md={{ size: 12 }}>
                  <div className="remove-officemate-modal-note">
                    <div className="bwai-remove-note-title">
                      <img
                        src={warningIcon}
                        style={{ width: "18px" }}
                      />
                      <span style={{ marginLeft: "10px" }}>Important Note</span>
                    </div>
                    <div className="bwai-remove-note-body">
                      Removing an Enterprise Member will deny them access to the
                      platform. You can always invite them back, but their
                      account will be reset.
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Cancel first, destructive last and right-aligned: the old
                  Bootstrap columns put the irreversible action on the left. */}
              <div className="bwai-remove-modal-actions">
                <Button
                  className="cancel-button"
                  onClick={() => {
                    this.setState((state) => ({
                      showRemoveUserConfirmationModal: !state.showRemoveUserConfirmationModal,
                    }));
                  }}
                >
                  <span className="remove-officemate-modal-cancel-btn-txt">
                    Cancel
                  </span>
                </Button>
                <Button
                  className="remove-officmate-button"
                  onClick={() => this.removeOfficeMate()}
                >
                  <span className="remove-officemate-modal-btn-txt">
                    Remove Member
                  </span>
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <Modal isOpen={showAddMember}>
            <ModalBody>
              <div className="row">
                <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 pick-office-modal-body-title">
                  Add {officeMate.firstName} {officeMate.lastName} to Your
                  Office
                </div>
              </div>
              <div className="row mt10">
                <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 col-md-offset-right-1 archive-modal-msg">
                  You are about to add {officeMate.firstName}{" "}
                  {officeMate.lastName} to Your Office. Please confirm this
                  action.
                </div>
              </div>
              <div className="row mt30">
                <div className="offset-md-1 col-sm-10 col-md-10">
                  <InfoMessage
                    iconLeft=""
                    msg="Important Note."
                    subMsg="Once added, this member will have all the permissions that users in your office have."
                  />
                </div>
              </div>
              <div className="row mt30">
                <div className="offset-md-1 col-sm-5 col-md-5">
                  <Button
                    onClick={() => this.addOfficeMate(officeMate)}
                    className="float-right invite-button-bg w100"
                  >
                    <span className="archiveBtnTxt">Add Member to Office</span>
                  </Button>
                </div>
                <div className="col-sm-3 col-md-3">
                  <Button
                    className="float-left goBackBtn w100"
                    onClick={() => {
                      this.setState({ showAddMember: false });
                    }}
                  >
                    <span className="goBackBtnTxt">Cancel</span>
                  </Button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      );
    };

    const hasMobileNumber = officeMateMobileNumber && profilePicValidityCheck(officeMateMobileNumber);
    return (
        <FormGroup
          style={{ height: formHeight }}
          className="mlmr0 officemate-row"
          row
        >
          <Col
            xs={2}
            sm={2}
            className={` d-flex align-items-center cursorPointer users-cell users-cell-name`}
            style={columnWidthStyle(columnWidths, "name")}
          >
            {officeMate &&
            !officeMate.orgAdmin &&
            this.props.user.role == "Admin" &&
            this.props.user._id != officeMate._id ? (
              <CheckBox
                className="mr-2"
                checked={removeChecked}
                onChange={() => {
                  if (userSelectedForRemove) {
                    userSelectedForRemove(officeMate._id);
                  }
                }}
              />
            ) : (
              <CheckBox
                className="mr-2"
                style={{
                  visibility: "hidden",
                }}
              />
            )}
            <div
              className="align-items-center mlmr0 d-flex flex-fill om-name-wrap"
              onClick={!editNameOpen ? this.navigateToProfile : undefined}
            >
              <div className="flex-shrink-1">{officeMateImageView}</div>
              <div
                className="flex-fill ml20 cursor-pointer om-name-text"
                style={{  wordBreak: "break-word" }}
              >
                <React.Fragment>
                  {officeMateFirstName || officeMateLastName || editNameOpen ? (
                  <div>
                    {editNameOpen &&
                      <div onClick={(e) => e.stopPropagation()}>
                        <div className="d-flex">
                          <Input
                            placeholder="First Name"
                            value={officeMateFirstNameDraft}
                            onChange={(e) => {
                              this.setState({
                                officeMateFirstNameDraft: e.target.value,
                              });
                            }}
                            onClick={(e) => e.stopPropagation()}
                            className="mr-2"
                          />
                          <Input
                            placeholder="Last Name"
                            value={officeMateLastNameDraft}
                            onChange={(e) => {
                              this.setState({
                                officeMateLastNameDraft: e.target.value,
                              });
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        {this.renderEditActions(this.saveOfficeMateNames, this.closeNameEditor)}
                      </div>}
                   
                  </div>
                ) : (
                  <span className="officemate-email">{EMPTY_VALUE_LABEL}</span>
                )}

                 {!editNameOpen&&<span>
                        <span className="d-flex align-items-center">
                          {/* Always the saved name, never the drafts. */}
                          <span className="officemate-firstname">
                            {officeMateFirstName}
                            {officeMateFirstName ? " " : ""}
                            <span className="officemate-lastname">
                              {officeMateLastName}
                            </span>
                          </span>
                          {officeMate.isPasswordChanged && (
                            <span className="ml-2 d-flex align-items-center flex-shrink-0">
                              <LuBadgeCheck size={14} color="green" />
                            </span>
                          )}
                        </span>
                      </span>}
                </React.Fragment>
                

<div className="users_gp_members">
                      {renderGenderPronoun(officeMate)}
                      {!officeMate.isPasswordChanged &&
                      officeMate.lastInvitedAt ? (
                        <span>
                          (last invited{" "}
                          {moment(officeMate.lastInvitedAt).format(
                            "MMM DD, YYYY"
                          )}
                          {officeMate.lastInviteVia &&
                          Array.isArray(officeMate.lastInviteVia) &&
                          officeMate.lastInviteVia.length ? (
                            <span className="ml-1" style={{ fontSize: "15px" }}>
                              {officeMate.lastInviteVia.includes("EMAIL") && (
                                <BiMailSend />
                              )}{" "}
                              {officeMate.lastInviteVia.includes("SMS") && (
                                <MdOutlineMobileFriendly />
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          )
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
              </div>
              {!editNameOpen && (((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && (
                <BiEditAlt
                  onClick={(e) => {
                    e.stopPropagation();
                    this.openNameEditor();
                  }}
                  className="ml-auto flex-shrink-0 cursor-pointer om-row-action"
                />
              )}
            </div>
          </Col>

            <Col
              xs={showUserIdColumn ? 2 : 3}
              sm={showUserIdColumn ? 2 : 3}
              className={` d-flex align-items-center users-cell users-cell-email`}
              style={columnWidthStyle(columnWidths, "email")}
            >
              {editEmailOpen ? (
                <div className="w-100">
                  <Input
                    value={officeMateEmailDraft}
                    onChange={(e) => {
                      this.setState({
                        officeMateEmailDraft: e.target.value,
                      });
                    }}
                  />
                  {this.renderEditActions(this.saveOfficeMateEmail, this.closeEmailEditor)}
                </div>
              ) : (
                <div className="d-flex align-items-center w-100">
                  <span
                    className="font-13px"
                    style={{ wordBreak: "break-all" }}
                    data-tip={displayedEmail}
                  >
                    {displayedEmail}
                  </span>
                  {(((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && (
                    <BiEditAlt
                      onClick={this.openEmailEditor}
                      className="ml-2 flex-shrink-0 cursor-pointer om-row-action"
                    />
                  )}
                </div>
              )}

              <ReactTooltip />
            </Col>
            {showUserIdColumn && (
              <Col
                xs={1}
                sm={1}
                className="d-flex align-items-center justify-content-center users-cell users-cell-employeeId"
                style={columnWidthStyle(columnWidths, "employeeId")}
              >
                {userRole.toLowerCase().includes('admin') &&
                  this.renderEmployeeIdCell("ml-2 flex-shrink-0 cursor-pointer om-row-action")}
              </Col>
            )}

            <Col
              xs={2}
              sm={2}
              className={` d-flex align-items-center users-cell users-cell-mobileNumber`}
              style={columnWidthStyle(columnWidths, "mobileNumber")}
            >
              {/* {(((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && ( */}
              {userRole.toLowerCase().includes('admin') && (

                <div className="w-100">
                  {editPhoneNumberOpen ? (
                    <div className="">
                      <PhoneInputWithCountrySelect
                        placeholder="Enter Mobile number"
                        value={officeMateMobileNumberDraft}
                        onChange={(v) => {
                          this.setState({
                            officeMateMobileNumberDraft: v || "",
                          });
                        }}
                        className="form-control p-0"
                        defaultCountry="US"
                        style={{
                          width: "200px",
                        }}
                      />
                      {this.renderEditActions(this.saveOfficeMateMobileNumber, this.closeMobileNumberEditor)}
                    </div>
                  ) : (
                    <div className={`d-flex align-items-center${hasMobileNumber ? "" : " om-cell-empty"}`}>
                      <span
                        className="om-cell-text"
                        style={{
                          wordBreak: "break-all",
                          fontSize: "13px",
                        }}
                      >
                        {hasMobileNumber
                          ? officeMateMobileNumber
                          : EMPTY_VALUE_LABEL}
                      </span>
                      {(((this.props.user._id == officeMate._id) && this.props.user.role === "Admin") || this.props.user.orgAdmin || ((this.props.user.role === "Admin") && (officeMateRole.value === "User"))) && (
                        <BiEditAlt
                          onClick={this.openMobileNumberEditor}
                          className="ml-2 flex-shrink-0 cursor-pointer om-row-action"
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
              {/* )} */}
            </Col>

            <Col
              xs={2}
              sm={2}
              className="d-flex align-items-center justify-content-center users-cell users-cell-addedDate"
              style={columnWidthStyle(columnWidths, "addedDate")}
            >
              {userRole.toLowerCase().includes('admin') && (
                <span className="font-13px" style={{ wordBreak: "break-all" }}>
                  {officeMate.createDate
                    ? moment(officeMate.createDate).format("MMM Do, YYYY")
                    : EMPTY_VALUE_LABEL}
                </span>
              )}
            </Col>

            <Col
              xs={2}
              sm={2}
              className="d-flex align-items-center justify-content-center users-cell users-cell-role"
              style={columnWidthStyle(columnWidths, "role")}
            >
              {roleView}
            </Col>
            {/* {this.renderUserOffices(officeMate)} */}

          <Col
            xs={1}
            sm={1}
            className="d-flex align-items-center justify-content-center users-cell users-cell-actions"
            style={columnWidthStyle(columnWidths, "actions")}
          >
            {moreView}
          </Col>
          {modalUI()}
        </FormGroup>
      );
  }
}
